import React from 'react'
import { Article } from '../../types'
import { Link } from 'react-router-dom'

const ArticleCard = ({article}:{article:Article}) => {
  return (
    <Link to={`/articles/${article.id}`} className=' h-full '>
        <div className=' h-1/2'>
            <img className=' h-full w-full' src={article.image} alt="article-image" loading='lazy' />
        </div>
        <div className=' p-4'>
            <p className=' text-textSecond mb-3 xs:text-sm sm:text-base'>{article.country}</p>
            <p className="xs:text-base sm:text-lg line-clamp-2">{article.title}</p>
        </div>
    </Link>
  )
}

export default ArticleCard